import React, { useState, useEffect } from 'react';

import AirportServices from 'services/AirportServices';
import useToggleDrawer from 'hooks/useToggleDrawer';
import PageTitle from 'components/Typography/PageTitle';
import MainDrawer from 'components/drawer/MainDrawer';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound'; // Import NotFound component
import { useContext } from 'react';
import { SidebarContext } from 'context/SidebarContext';
import { FiRefreshCcw } from 'react-icons/fi';
import DeleteModal from 'components/modal/DeleteModal';
import useAsync from 'hooks/useAsync';
import {
    Card,
    CardBody,
    Input,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
    Button,
} from '@windmill/react-ui';
import AirportCityTable from 'components/airportcity/AirportCityTable';
import { FiPlus } from 'react-icons/fi';
import AirportDrawer from 'components/drawer/AirportDrawer';
import sidebar from 'routes/sidebar';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import ItineraryPeriodicMarginTable from 'components/overrideMargin/ItineraryPeriodicMarginTable';
import ItineraryPeriodicMarginDrawer from 'components/drawer/ItineraryPeriodicMarginDrawer';
import { itineraryOverRideMarginServices } from 'services/marginServices';

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const ItineraryPeriodicMargin = () => {
    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;
    const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
    const [searchText, setSearchText] = useState('');
    const { data, loading, error } = useAsync(() =>
        itineraryOverRideMarginServices.getOverRideMargin()
    );
    const isDataArray = Array.isArray(data?.data);
    const safeData = isDataArray ? data?.data : [];
    const [status, setStatus] = useState('');

    const isAdmin = adminInfo?.id === 1;

    const hideView = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'airport city' && perm.view === 1
        );

    const hideDelete = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'airport city' && perm.delete === 1
        );

    const hideEdit = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'airport city' && perm.edit === 1
        );

    const hideAdd = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'airport city' && perm.add === 1
        );

    const hideExport = isAdmin
        ? true
        : adminInfo?.permission?.some(
            (perm) => perm.id_tab === 'airport city' && perm.export === 1
        );
    useEffect(() => {
        if (data?.status) {
            setStatus(data.status);
        } else {
            setStatus(false);
        }
    }, [data?.status]);

    const { title, serviceId } = useToggleDrawer();

    const csvData = [
        ['S.No', 'Airport Name', 'Code', 'Parking'],
        ...safeData.map(({ airportname, airportcode, parking }, index) => [
            index + 1,
            airportname,
            airportcode,
            parking,
        ]),
    ];

    const searchTerms = searchText.toLowerCase().split(' ');

    const filteredData = safeData.filter((item) =>
        searchTerms.every(
            (term) =>
            (item.city_name !== null &&
                item.city_name.toLowerCase().includes(term))
        )
    );

    const marginHeaders =
        filteredData.length > 0
            ? Object.entries(filteredData[0]?.margin_details || {})
            : [];

    const handleRefresh = () => {
        setIsUpdate(true);
    };
    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />

                    <style>{style}</style>
                    <PageTitle sidebar={sidebar().sidebar} />

                    <MainDrawer>
                        <ItineraryPeriodicMarginDrawer id={serviceId} />
                    </MainDrawer>

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <form className="gap-6 flex items-center">
                                <div className="flex-1">
                                    <Input
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                        type="search"
                                        name="search"
                                        value={searchText}
                                        autoComplete="off"
                                        onChange={(e) => setSearchText(e.target.value)}
                                        placeholder="Quick Search"
                                    />
                                </div>

                                {hideAdd && (
                                    <Button
                                        onClick={toggleDrawer}
                                        className="w-56 rounded-md h-10"
                                    >
                                        <span className="mr-3">
                                            <FiPlus />
                                        </span>
                                        Add Periodic Hike Margin
                                    </Button>
                                )}

                                {/* {hideExport && (
                                    <ExportDataXlsx
                                        title="Airport List"
                                        exportDataXlsx={csvData}
                                        fileNames="Airport List"
                                    />
                                )} */}

                                <FiRefreshCcw
                                    onClick={() => {
                                        handleRefresh();
                                    }}
                                    cursor="pointer"
                                />
                            </form>
                        </CardBody>
                    </Card>

                    <DataWrapper loading={loading} error={error} status={status}>
                        {filteredData.length > 0 ? (
                            <TableContainer
                                className="mb-8"
                                style={{
                                    maxHeight: '65vh',
                                    overflow: 'scroll',
                                    scrollbarWidth: 'thin',
                                }}
                            >
                                <Table>
                                    <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                                        <tr>
                                            <TableCell className="text-center">Sl.No.</TableCell>
                                            <TableCell className="text-center">
                                                City
                                            </TableCell>
                                            <TableCell className="text-center">
                                                Start Date
                                            </TableCell>
                                            <TableCell className="text-center">End Date</TableCell>
                                            {marginHeaders.map(([id, vehicle]) => (
                                                <TableCell
                                                    key={id}
                                                    className="text-center text-wrap"
                                                >
                                                    {vehicle.name.replace(/^Tempo Traveller/i, "Tempo")} (%)
                                                </TableCell>
                                            ))}
                                            <TableCell className="text-center">Status</TableCell>
                                            <TableCell className="text-center">Actions</TableCell>
                                        </tr>
                                    </TableHeader>

                                    <ItineraryPeriodicMarginTable
                                        overrideMarginData={filteredData}
                                        hideEdit={hideEdit}
                                        hideDelete={hideDelete}
                                    />
                                </Table>
                            </TableContainer>
                        ) : (
                            <NotFound title="There are no Override Margins" />
                        )}
                    </DataWrapper>
                </>
            )}
        </>
    );
};

export default ItineraryPeriodicMargin;
